export default __webpack_public_path__ + "static/media/smallimages.dcbb397c.png";